/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

/**
 *
 * Class to represent an AWS Serverless Image Handler request
 *
 * @author nchapman@frontier.co.uk
 *
 */
export class ImageRequest {

    private cloudfrontUrl: string = process.env.VUE_APP_IMG_SRV || 'https://image-service.zaonce.net';
    private readonly bucket: string;
    private readonly key: string;
    // tslint:disable-next-line
    private _edits?: ImageServiceEdits;
    // tslint:disable-next-line
    private _size?: string | number;

    /**
     * Constructor
     *
     * @param bucket
     * @param key
     */
    constructor(bucket: string, key: string) {
        this.bucket = bucket;
        this.key = decodeURI(key);
    }

    /**
     * edits Setter
     *
     * @param value
     */
    set edits(value: ImageServiceEdits | undefined) {
        this._edits = value;
    }

    /**
     * edits Getter
     */
    get edits(): ImageServiceEdits | undefined {
        return this._edits;
    }

    /**
     * Get AWS SIH Url
     *
     * @return string
     */
    public getURl(): string {

        if (!this._edits || this._size) {
            // @todo Log error with instance of logLevel
        }

        return this.cloudfrontUrl + '/' + btoa(JSON.stringify(this));
    }

    public toJSON(): {
        bucket: string;
        key: string;
        edits: ImageServiceEdits | undefined;
    } {
        return {
            bucket: this.bucket,
            key: this.key,
            edits: this._edits,
        };
    }

}
